import "./balance.scss";
import "react-day-picker/dist/style.css";

import { DateRange, DayPicker } from "react-day-picker";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../features/helpers";
import { fetchOrganizationBalances, getAllBalance, getAllBalanceList, getClientBalances, setSelectedUserIdForBalance, resetBalanceState } from "../../../store/BalanceSlice";
import { Filter, RefreshCw, Users2, Cable } from "lucide-react";

import {
    PageCard, SectionTitle, EmptyState, FormField, ToggleSwitch,
} from "../../../components/ui";
import { fetchClientsByOrganization, getClientList, UserInfo } from "../../../store/UserSlice";
import BalanceClientList from "./component/BalanceClientList";

type Category = "customer" | "supplier";

const Balance = () => {

    const dispatch                                  = useAppDispatch();
    const list: any                                 = useAppSelector(getAllBalanceList);
    const clientList: Array<UserInfo>               = useAppSelector(getClientList)
    const clientListBalancesResponse: Array<any>    = useAppSelector(getClientBalances)

    const [category, setCategory]                   = useState<Category>("customer");
    const [range, setRange]                         = useState<DateRange | undefined>();
    const [loading, setLoading]                     = useState<boolean>(false);
    const [clients, setClients]                     = useState<Array<UserInfo>>([])
    const [selectedUserId, setSelectedUserId]       = useState<string>("")

    const [clientsBalance, setClientsBalance]       = useState<Array<UserInfo>>([])


    useEffect(() => {
        setLoading(true);
        //Promise.resolve(dispatch(getAllBalance())).finally(() => setLoading(false));
        dispatch(fetchClientsByOrganization())

        return () => {
            dispatch(resetBalanceState())
        }
    }, [dispatch]);

    useEffect( () => {
        setClients(clientList);
    }, [clientList])

    const refresh = () => {
        setLoading(true);
        Promise.resolve(dispatch(getAllBalance())).finally(() => setLoading(false));
    };

    const safeList: any[] = Array.isArray(list) ? list : [];

    const handleFilter = () => {
        dispatch(fetchOrganizationBalances(range))    
    }
    
    const handleChange = (e:any) => {
        setSelectedUserId(e.target.value);
        dispatch(setSelectedUserIdForBalance(e.target.value))
    }

    const isFilterReady = () => {
        return !range?.from || !range?.to || !selectedUserId;
    }

    // repsonse

    useEffect( () => {
        console.dir(clientListBalancesResponse);
        setClientsBalance(clientListBalancesResponse);
    }, [clientListBalancesResponse]);

    return (
        <div className="balance-wrapper">

            <div className="balance-header">
                <h1 className="page-title">
                    Saldos
                    <small>Lista de saldos por dia, cliente e carteira.</small>
                </h1>
                <button
                    className="btn-pill ghost refresh-btn"
                    onClick={refresh}
                    aria-label="Atualizar"
                    disabled={loading}
                >
                    <RefreshCw size={14} className={loading ? "spin" : ""} />
                    Atualizar
                </button>
            </div>

            {/* filtros */}
            <PageCard className="filters-card">
                <SectionTitle icon={Filter}>Filtros</SectionTitle>

                <div className="filters-grid">

                    <div className="filters-left">
                        <FormField label="Range desejado">
                            <div className="rdp-wrapper">
                                <DayPicker
                                    mode="range"
                                    selected={range}
                                    onSelect={setRange}
                                    numberOfMonths={2}
                                    disabled={{ after: new Date() }}
                                    defaultMonth={new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)}
                                />
                            </div>
                        </FormField>
                    </div>

                    <div className="filters-right">
                        <FormField label="Tipo de Usuario">
                            <ToggleSwitch
                                ariaLabel="Tipo de usuario"
                                value={category}
                                onChange={(k: string) => setCategory(k as Category)}
                                options={[
                                    { key: "customer", label: "Cliente",    icon: Users2 },
                                    { key: "supplier", label: "Fornecedor", icon: Cable  },
                                ]}
                            />
                        </FormField>

                        <FormField label="Nome" htmlFor="balance-name">
                            <select id="balance-name" defaultValue="" onChange={handleChange}>
                                <option value="">Selecione</option>
                                {clients.map((user: UserInfo, index: number) => (
                                    <option key={index} value={user.id}>
                                        {user.name}
                                    </option>
                                ))}
                            </select>
                        </FormField>

                        <button className="btn-pill primary filter-submit" onClick={handleFilter} disabled={isFilterReady()}>
                            <Filter size={14} /> Filtrar
                        </button>
                    </div>
                </div>
            </PageCard>

            <div className="results-header">
                <h2>Resultados</h2>
                <small>
                    {clientsBalance.length} {clientsBalance.length === 1 ? "carteira" : "carteiras"}
                </small>
            </div>
            
             {/* resultados */}
            {clientsBalance.length === 0 && !loading && (
                <PageCard>
                    <EmptyState
                        icon={Filter}
                        title="Sem resultados."
                        description="Ajuste os filtros e clique em Filtrar."
                    />
                </PageCard>
            )}

            {clientsBalance.length > 0 && <BalanceClientList items={clientsBalance} />}

        </div>
    );
};

export default Balance;
